import React, { Component } from 'react';

class ContainerLeft extends Component {
    constructor(props){
        super(props);
        this.state = {
            collLeft: [
                {
                    id: 1,
                    subtitle: 'Capítulo 1',
                    title: 'Herramientas de Álgebra Lineal',
                    text: 'Se presentan los fundamentos matemáticos necesarios para comprender el control adaptativo y las redes neuronales recurrentes: producto escalar, normas, convolución, autovalores, autovectores, SVD y transformadas de Fourier, entre otros conceptos esenciales.'
                },
                {
                    id: 2,
                    subtitle: 'Capítulo 2',
                    title: 'Representación de Sistemas Dinámicos',
                    text: 'Aprenderás a modelar sistemas dinámicos tanto en el dominio continuo como en el discreto, utilizando espacio de estados, funciones de transferencia y ecuaciones en diferencias, además de introducir las arquitecturas FIR, IIR y redes neuronales recurrentes.'
                }
            ]
        }
    }
    render() {
        return (
            <div className="chapter-list border-right-0">
                 {
                    this.state.collLeft.map((data,i) => (
                        <div className="chapter-item" key={i}>
                            <h4><span>{data.subtitle} </span> {data.title}</h4>
                            <p>{data.text} </p>
                        </div>
                    ))
                }
            </div>
        );
    }
}

export default ContainerLeft;
